import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AppProvider } from './context/AppProvider';
import MainLayout from './components/Layout/MainLayout';
import CheckoutBuilder from './pages/CheckoutBuilder';
import OrderConfirmationBuilder from './pages/OrderConfirmationBuilder';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppProvider>
        <Router>
          <MainLayout>
            <Routes>
              <Route path="/" element={<Navigate to="/checkout" replace />} />
              <Route path="/checkout" element={<CheckoutBuilder />} />
              <Route path="/order-confirmation" element={<OrderConfirmationBuilder />} />
            </Routes>
          </MainLayout>
        </Router>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
